var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10, _symbol11, _symbol12, _symbol13, _symbol14, _symbol15, _symbol16, _symbol17, _symbol18, _symbol19, _symbol20, _symbol21, _symbol22, _symbol23;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSymbolDefs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-login",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 3.2,
    d: "M20.8 1.6h1.92c2.688 0 4.032 0 5.059 0.523 0.903 0.46 1.637 1.194 2.098 2.098 0.523 1.027 0.523 2.371 0.523 5.059v13.44c0 2.688 0 4.032-0.523 5.059-0.46 0.903-1.195 1.637-2.098 2.098-1.027 0.523-2.371 0.523-5.059 0.523h-1.92M12.8 8l8 8M20.8 16l-8 8M20.8 16h-19.2"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-logout",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 3.5556,
    d: "M21.926 23.407l7.407-7.407M29.333 16l-7.407-7.407M29.333 16h-17.778M11.556 2.667h-1.778c-2.489 0-3.734 0-4.684 0.484-0.836 0.426-1.516 1.106-1.942 1.942-0.484 0.951-0.484 2.195-0.484 4.684v12.444c0 2.489 0 3.734 0.484 4.684 0.426 0.836 1.106 1.516 1.942 1.942 0.951 0.484 2.195 0.484 4.684 0.484h1.778"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-Vector-3",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.787 14.449l1.542 1.049-29.329 0.001v0.821l29.145-0.001-1.453 0.835 0.409 0.711 3.343-1.921-3.196-2.173-0.462 0.679z"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-Vector-2",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.133 17.368l-1.542-1.049 29.329-0.001v-0.82l-29.145 0.001 1.453-0.835-0.409-0.711-3.343 1.921 3.196 2.173 0.462-0.679z"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-Icon-2",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.4471,
    d: "M2.588 30.353l7.834-3.013c0.501-0.193 0.752-0.289 0.986-0.415 0.208-0.112 0.407-0.241 0.593-0.386 0.21-0.163 0.4-0.353 0.78-0.732l15.924-15.924c1.559-1.559 1.559-4.088 0-5.647s-4.088-1.559-5.647 0l-15.924 15.924c-0.38 0.38-0.569 0.569-0.733 0.78-0.145 0.187-0.274 0.385-0.386 0.593-0.126 0.234-0.222 0.485-0.415 0.986l-3.013 7.834zM2.588 30.353l2.906-7.554c0.208-0.541 0.312-0.811 0.49-0.935 0.156-0.108 0.349-0.149 0.535-0.113 0.213 0.041 0.418 0.246 0.828 0.655l3.189 3.189c0.41 0.41 0.614 0.614 0.655 0.828 0.036 0.186-0.005 0.379-0.114 0.535-0.124 0.178-0.394 0.282-0.935 0.49l-7.554 2.906z"
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-Vector-1",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.76 18.88l-3.48-3.48c-0.293-0.293-0.66-0.433-1.099-0.419-0.441 0.013-0.807 0.166-1.101 0.459s-0.44 0.667-0.44 1.12c0 0.453 0.147 0.827 0.44 1.12l4.56 4.56c0.293 0.293 0.667 0.44 1.12 0.44s0.827-0.147 1.12-0.44l9.080-9.080c0.293-0.293 0.434-0.66 0.421-1.101-0.014-0.439-0.168-0.806-0.461-1.099s-0.667-0.44-1.12-0.44c-0.453 0-0.827 0.147-1.12 0.44l-7.92 7.92zM16 32c-2.213 0-4.293-0.42-6.24-1.261s-3.64-1.979-5.080-3.419-2.58-3.133-3.419-5.080c-0.841-1.947-1.261-4.027-1.261-6.24s0.42-4.293 1.261-6.24c0.839-1.947 1.979-3.64 3.419-5.080s3.133-2.58 5.080-3.421c1.947-0.839 4.027-1.259 6.24-1.259s4.293 0.42 6.24 1.259c1.947 0.841 3.64 1.981 5.080 3.421s2.58 3.133 3.419 5.080c0.84 1.947 1.261 4.027 1.261 6.24s-0.42 4.293-1.261 6.24c-0.84 1.947-1.979 3.64-3.419 5.080s-3.133 2.58-5.080 3.419c-1.947 0.84-4.027 1.261-6.24 1.261zM16 28.8c3.547 0 6.567-1.246 9.061-3.739 2.493-2.494 3.739-5.514 3.739-9.061s-1.246-6.567-3.739-9.061c-2.494-2.493-5.514-3.739-9.061-3.739s-6.566 1.246-9.059 3.739c-2.494 2.494-3.741 5.514-3.741 9.061s1.247 6.567 3.741 9.061c2.493 2.493 5.513 3.739 9.059 3.739z"
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-Vector",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4 20.8h3.2v3.2h-3.2v-3.2zM14.4 8h3.2v9.6h-3.2v-9.6zM15.984 0c-8.832 0-15.984 7.168-15.984 16s7.152 16 15.984 16c8.848 0 16.016-7.168 16.016-16s-7.168-16-16.016-16zM16 28.8c-7.072 0-12.8-5.728-12.8-12.8s5.728-12.8 12.8-12.8c7.072 0 12.8 5.728 12.8 12.8s-5.728 12.8-12.8 12.8z"
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-chevron-right",
    viewBox: "0 0 6 12",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.75 10.5L5.25 6L0.75 1.5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-chevron-down",
    viewBox: "0 0 18 18"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2,
    d: "M4.5 6.75L9 11.25L13.5 6.75"
  }))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-chevron-left",
    viewBox: "0 0 6 12",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.25 10.5L0.75 6L5.25 1.5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-x-close",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M24 8l-16 16"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M8 8l16 16"
  }))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-shape",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.36 7.644c0-0.91 0.001-1.566 0.045-2.078 0.045-0.523 0.124-0.715 0.161-0.778 0.010-0.016 0.013-0.019 0.019-0.023l0.001-0.001c0.010-0.008 0.054-0.037 0.165-0.072 0.249-0.077 0.683-0.134 1.449-0.134s1.2 0.057 1.449 0.134c0.111 0.034 0.155 0.064 0.166 0.072l0.001 0.001c0.005 0.004 0.009 0.006 0.019 0.023 0.037 0.062 0.116 0.254 0.161 0.778 0.044 0.512 0.045 1.168 0.045 2.078v16.711c0 1.076-0.061 1.804-0.162 2.298-0.101 0.497-0.219 0.637-0.239 0.658-0.007 0.008-0.014 0.014-0.035 0.024-0.027 0.013-0.087 0.035-0.203 0.055-0.265 0.046-0.613 0.050-1.203 0.050-0.599 0-0.951-0.004-1.218-0.050-0.117-0.020-0.176-0.042-0.201-0.054-0.019-0.009-0.024-0.014-0.029-0.020-0.018-0.019-0.134-0.157-0.233-0.656-0.099-0.496-0.158-1.226-0.158-2.304v-16.711zM27.2 1.84c-1.546 0-3.135 0.163-3.966 1.549-0.363 0.604-0.484 1.301-0.539 1.945-0.055 0.642-0.055 1.413-0.055 2.26v16.761c0 1.145 0.060 2.081 0.21 2.835 0.149 0.751 0.412 1.446 0.914 1.982 0.527 0.564 1.17 0.797 1.759 0.898 0.521 0.089 1.104 0.089 1.613 0.089h0.128c0.502 0 1.080 0 1.6-0.089 0.587-0.101 1.228-0.334 1.756-0.894 0.504-0.534 0.771-1.228 0.924-1.981 0.154-0.756 0.216-1.694 0.216-2.841v-16.761c0-0.848 0-1.619-0.055-2.26-0.055-0.643-0.176-1.34-0.539-1.945-0.832-1.386-2.42-1.549-3.966-1.549zM14.206 12c-0.040 0.361-0.042 0.781-0.042 1.333l0 5.867v5.867c0 0.013-0 0.026-0.001 0.039-0.040 1.375 0.211 1.84 0.359 2 0.129 0.138 0.452 0.335 1.476 0.335 1.001 0 1.334-0.195 1.471-0.34 0.152-0.161 0.408-0.627 0.364-1.99-0-0.015-0.001-0.029-0.001-0.044v-11.733c0-0.553-0.002-0.973-0.042-1.333-0.040-0.355-0.106-0.537-0.164-0.634l-0.002-0.003c-0.037-0.064-0.237-0.402-1.627-0.402s-1.589 0.339-1.627 0.402l-0.002 0.003c-0.058 0.097-0.125 0.279-0.164 0.634zM12.037 9.968c0.766-1.279 2.183-1.728 3.962-1.728s3.196 0.448 3.962 1.728c0.341 0.57 0.474 1.188 0.534 1.732 0.058 0.526 0.058 1.090 0.058 1.594v11.752c0.047 1.561-0.192 2.954-1.105 3.921-0.932 0.988-2.243 1.193-3.45 1.193-1.219 0-2.535-0.203-3.464-1.199-0.905-0.97-1.133-2.364-1.090-3.914v-5.848l-0-5.867v-0.040c-0-0.504-0-1.068 0.058-1.594 0.060-0.544 0.193-1.163 0.534-1.732zM3.003 20.031c-0.042 0.422-0.043 0.932-0.043 1.613v4.426c0 0.769 0.186 0.979 0.276 1.056 0.147 0.124 0.543 0.314 1.564 0.314 0.998 0 1.401-0.188 1.555-0.317 0.097-0.082 0.285-0.296 0.285-1.052v-4.402l-0.011-0.324c-0.018-0.527-0.032-0.939-0.071-1.302-0.047-0.436-0.118-0.64-0.175-0.739l-0.001-0.002c-0.014-0.032-0.153-0.342-1.582-0.342-1.436 0-1.603 0.313-1.626 0.356l-0.002 0.003c-0.055 0.094-0.127 0.29-0.169 0.712zM0.828 17.941c0.784-1.335 2.253-1.701 3.973-1.701 1.723 0 3.177 0.369 3.946 1.717 0.332 0.581 0.455 1.224 0.516 1.794 0.051 0.474 0.069 1.010 0.086 1.537 0.003 0.104 0.007 0.207 0.010 0.309l0 0.016 0 0.033v4.426c0 1.189-0.307 2.339-1.257 3.136-0.893 0.749-2.090 0.953-3.303 0.953-1.226 0-2.429-0.203-3.321-0.957-0.948-0.802-1.239-1.956-1.239-3.132v-4.47c-0-0.627-0-1.267 0.057-1.838 0.058-0.585 0.186-1.234 0.531-1.821z"
  }))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-plus-in-a-circle",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.9091,
    d: "M16 10.182v11.636M10.182 16h11.636M30.545 16c0 8.033-6.512 14.545-14.545 14.545s-14.545-6.512-14.545-14.545c0-8.033 6.512-14.545 14.545-14.545s14.545 6.512 14.545 14.545z"
  }))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-plus",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M16 6.667v18.667M6.667 16h18.667"
  }))), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-circle-broken-right",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6,
    d: "M4.451 9.333c2.305-3.985 6.614-6.667 11.55-6.667 7.364 0 13.333 5.97 13.333 13.333s-5.97 13.333-13.333 13.333c-4.935 0-9.244-2.681-11.55-6.667"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6,
    d: "M16 21.333l5.333-5.333-5.333-5.333"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6,
    d: "M2.667 16h18.667"
  }))), _symbol16 || (_symbol16 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-Icon",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.7733,
    d: "M1.422 30.578l7.892-3.036c0.505-0.194 0.757-0.291 0.993-0.418 0.21-0.113 0.41-0.243 0.598-0.388 0.212-0.164 0.403-0.356 0.785-0.738l16.042-16.042c1.571-1.571 1.571-4.118 0-5.689s-4.118-1.571-5.689 0l-16.042 16.042c-0.382 0.382-0.574 0.574-0.738 0.785-0.146 0.188-0.276 0.388-0.388 0.598-0.127 0.236-0.224 0.489-0.418 0.993l-3.035 7.892zM1.422 30.578l2.927-7.61c0.209-0.545 0.314-0.817 0.494-0.942 0.157-0.109 0.351-0.15 0.539-0.114 0.215 0.041 0.421 0.247 0.834 0.66l3.213 3.213c0.413 0.413 0.619 0.619 0.66 0.834 0.036 0.188-0.005 0.382-0.114 0.539-0.125 0.18-0.397 0.284-0.942 0.494l-7.61 2.927z"
  }))), _symbol17 || (_symbol17 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-trash-04",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6,
    d: "M12 4h8"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6,
    d: "M4 8h24"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6,
    d: "M6.667 8l0.801 12.018c0.149 2.231 0.223 3.347 0.588 4.243 0.662 1.627 2.004 2.883 3.672 3.435 0.919 0.304 2.037 0.304 4.273 0.304v0c2.236 0 3.354 0 4.273-0.304 1.668-0.552 3.009-1.808 3.671-3.435 0.365-0.896 0.439-2.012 0.588-4.243l0.801-12.018"
  }))), _symbol18 || (_symbol18 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-user-check-01",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M21.333 24l2.667 2.667 5.333-5.333"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M16 20.667h-6c-1.861 0-2.791 0-3.548 0.23-1.705 0.517-3.038 1.851-3.555 3.556-0.23 0.757-0.23 1.687-0.23 3.548v0"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M13.333 16c3.314 0 6-2.686 6-6s-2.686-6-6-6c-3.314 0-6 2.686-6 6s2.686 6 6 6z"
  }))), _symbol19 || (_symbol19 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-calendar-check-02",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M28 13.333h-24M28 16.667v-4.933c0-2.24 0-3.36-0.436-4.216-0.383-0.753-0.995-1.365-1.748-1.748-0.856-0.436-1.976-0.436-4.216-0.436h-11.2c-2.24 0-3.36 0-4.216 0.436-0.753 0.383-1.365 0.995-1.748 1.748-0.436 0.856-0.436 1.976-0.436 4.216v11.2c0 2.24 0 3.36 0.436 4.216 0.383 0.753 0.995 1.365 1.748 1.748 0.856 0.436 1.976 0.436 4.216 0.436h5.6M21.333 2.667v5.333M10.667 2.667v5.333M19.333 25.333l2.667 2.667 6-6"
  }))), _symbol20 || (_symbol20 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-moon",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.656 17.393c-0.904 0.24-1.834 0.361-2.769 0.361-2.847 0-5.52-1.107-7.528-3.115-1.319-1.326-2.267-2.975-2.749-4.782s-0.484-3.709-0.002-5.516c0.060-0.226 0.060-0.464-0.001-0.689s-0.18-0.432-0.345-0.597c-0.165-0.165-0.371-0.284-0.597-0.344s-0.464-0.060-0.69 0c-2.262 0.603-4.327 1.79-5.985 3.443-5.197 5.197-5.197 13.657 0 18.857 1.235 1.242 2.705 2.227 4.323 2.898s3.354 1.014 5.106 1.009c1.752 0.005 3.487-0.338 5.105-1.008s3.087-1.655 4.322-2.897c1.654-1.659 2.841-3.724 3.444-5.988 0.060-0.226 0.059-0.463-0.002-0.689s-0.18-0.431-0.345-0.596-0.371-0.284-0.596-0.345c-0.226-0.061-0.463-0.061-0.689-0.001zM23.96 23.128c-0.988 0.993-2.163 1.781-3.458 2.317s-2.682 0.81-4.084 0.807c-1.402 0.003-2.79-0.271-4.085-0.807s-2.471-1.324-3.459-2.318c-4.157-4.159-4.157-10.927 0-15.085 0.803-0.802 1.731-1.47 2.747-1.977-0.149 1.919 0.119 3.847 0.784 5.653s1.712 3.447 3.070 4.811c1.361 1.362 3.002 2.412 4.808 3.077s3.736 0.931 5.656 0.777c-0.51 1.014-1.178 1.941-1.979 2.745z"
  }))), _symbol21 || (_symbol21 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-sun",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.324 16c0 3.681 2.995 6.676 6.676 6.676s6.676-2.995 6.676-6.676c0-3.681-2.995-6.676-6.676-6.676s-6.676 2.995-6.676 6.676zM16 11.991c2.211 0 4.009 1.799 4.009 4.009s-1.799 4.009-4.009 4.009c-2.211 0-4.009-1.799-4.009-4.009s1.799-4.009 4.009-4.009zM14.664 25.333h2.667v4h-2.667v-4zM14.664 2.667h2.667v4h-2.667v-4zM2.664 14.667h4v2.667h-4v-2.667zM25.331 14.667h4v2.667h-4v-2.667zM5.625 24.484l2.827-2.829 1.887 1.885-2.827 2.829-1.887-1.885zM21.653 8.459l2.829-2.829 1.885 1.885-2.829 2.829-1.885-1.885zM8.456 10.345l-2.829-2.829 1.887-1.885 2.827 2.829-1.884 1.885zM26.368 24.485l-1.885 1.885-2.829-2.829 1.885-1.885 2.829 2.829z"
  }))), _symbol22 || (_symbol22 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-menu-01",
    viewBox: "0 0 34 34"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 2.5,
    d: "M4.25 17H29.75"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 2.5,
    d: "M4.25 8.5H29.75"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 2.5,
    d: "M4.25 25.5H29.75"
  }))), _symbol23 || (_symbol23 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-pencil-01",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6,
    d: "M3.334 28.667l7.399-2.846c0.473-0.182 0.71-0.273 0.931-0.392 0.197-0.106 0.384-0.227 0.56-0.364 0.199-0.154 0.378-0.333 0.736-0.692l15.040-15.040c1.473-1.473 1.473-3.861 0-5.333s-3.86-1.473-5.333 0l-15.040 15.040c-0.359 0.359-0.538 0.538-0.692 0.736-0.137 0.176-0.259 0.364-0.364 0.56-0.119 0.221-0.21 0.458-0.392 0.931l-2.846 7.399zM3.334 28.667l2.744-7.135c0.196-0.511 0.295-0.766 0.463-0.883 0.147-0.102 0.329-0.141 0.505-0.107 0.201 0.038 0.395 0.232 0.782 0.619l3.012 3.012c0.387 0.387 0.58 0.58 0.619 0.782 0.034 0.176-0.005 0.358-0.107 0.505-0.117 0.168-0.372 0.267-0.883 0.463l-7.135 2.744z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-trash-2",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ea3d65",
    style: {
      stroke: "var(--color1, #ea3d65)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 3,
    d: "M4 8h24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ea3d65",
    style: {
      stroke: "var(--color1, #ea3d65)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 3,
    d: "M25.333 8v18.667c0 0.707-0.281 1.385-0.781 1.886s-1.178 0.781-1.886 0.781h-13.333c-0.707 0-1.386-0.281-1.886-0.781s-0.781-1.178-0.781-1.886v-18.667M10.666 8v-2.667c0-0.707 0.281-1.386 0.781-1.886s1.178-0.781 1.886-0.781h5.333c0.707 0 1.386 0.281 1.886 0.781s0.781 1.178 0.781 1.886v2.667"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ea3d65",
    style: {
      stroke: "var(--color1, #ea3d65)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 3,
    d: "M13.334 14.667v8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ea3d65",
    style: {
      stroke: "var(--color1, #ea3d65)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 3,
    d: "M18.666 14.667v8"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-star",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffac33",
    style: {
      fill: "var(--color2, #ffac33)",
      stroke: "var(--color2, #ffac33)"
    },
    stroke: "#ffac33",
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 1.6,
    d: "M16 1.714l4.030 7.638c0.212 0.402 0.599 0.683 1.047 0.761l8.509 1.472-6.019 6.193c-0.317 0.326-0.465 0.781-0.4 1.231l1.229 8.548-7.75-3.811c-0.408-0.201-0.886-0.201-1.294 0l-7.75 3.811 1.229-8.548c0.065-0.45-0.083-0.905-0.4-1.231l-6.019-6.193 8.509-1.472c0.448-0.078 0.835-0.359 1.047-0.761v0l4.030-7.638zM7.376 27.669c0 0 0-0 0-0l-0 0zM16.118 1.491l0-0c0 0-0 0-0 0z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-Star-2",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#cec9c1",
    style: {
      fill: "var(--color1, #cec9c1)",
      stroke: "var(--color1, #cec9c1)"
    },
    stroke: "#cec9c1",
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 1.7455,
    d: "M16 1.87l4.396 8.332c0.231 0.439 0.653 0.745 1.142 0.83l9.283 1.606-6.566 6.756c-0.346 0.356-0.507 0.852-0.436 1.343l1.341 9.325-8.454-4.157c-0.445-0.219-0.967-0.219-1.412 0l-8.454 4.157 1.341-9.325c0.071-0.491-0.091-0.987-0.436-1.343l-6.566-6.756 9.283-1.606c0.489-0.085 0.911-0.391 1.142-0.83v0l4.396-8.332zM6.592 30.184c0 0 0-0 0-0l-0 0zM16.128 1.627l0-0c0 0-0 0-0 0z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolDefs);
export default __webpack_public_path__ + "static/media/symbol-defs.2d4e93d2c30de0ce1e3bf58d4079fbe5.svg";
export { ForwardRef as ReactComponent };